
<div class="file-thumbnail-container mx-auto" *ngIf="view != 1">
  <div class="favorite-icon"
       [class.active]="productDetail.isUserFavorite"
       (click)="toggleFavorite($event)">
    ★
  </div>
  <div class="image-thumbnail-container text-center">
    <img class="image-thumbnail" [hidden]="productDetail.imageShow" src="../../../../../assets/images/Placeholder.png" (click)="clickThumbnail()">
    <img class="image-thumbnail" [hidden]="!productDetail.imageShow" src="{{productDetail.image}}" (load)="productDetail.imageShow = true" (click)="clickThumbnail()">
    <div class="discontinued" [hidden]="!isDiscontinued"></div>
    <div class="hover-container">
      <div class="image-hover" (click)="clickThumbnail()"></div>
      <div class="button-container">
        <button class="btn btn-danger" (click)="quickOrder2()">Add to Cart</button>
        <button class="btn btn-danger pull-right" (click)="quickOrder2()">Quick Order</button>
      </div>

    </div>
  </div>
  <div class="file-footer-container">
    <div class="product-name">{{productDetail.itemNumber}} </div>
    <div class="product-description">{{productDetail.description}} </div>
    <!--<div class="product-by">Fotiou Fine Molding By Design </div>-->
  </div>
</div>
  <div class="thumbnail-container" *ngIf="view == 1">
    <div class="left">
      <div class="image-thumbnail-container text-center" (click)="clickThumbnail()">
        <img class="image-thumbnail" [hidden]="!productDetail.imageShow" src="{{productDetail.image}}" (load)="productDetail.imageShow = true">
        <img class="image-thumbnail" [hidden]="productDetail.imageShow" src="../../../../../assets/images/Placeholder.png">        
        <div class="hover-container">
          <div class="image-hover" (click)="clickThumbnail()"></div>
          <div class="button-container">

            <button class="btn btn-danger" (click)="quickOrder2()">Add to Cart</button>
            <button class="btn btn-danger pull-right" (click)="quickOrder2()">Quick Order</button>
          </div>

        </div>
      </div>
    </div>
    <div class="mid">

    </div>
    <div class="right">
      <div class="row">
        <div class="col-md-6">
          <div class="product-name">{{productDetail.itemNumber}} </div>
          <div class="product-description">{{productDetail.description}} </div>
          <!--<div class="product-by">Fotiou Fine Molding By Design </div>-->
        </div>
        <div class="col-md-6">
          <div>
            <span class="mr-1 font-weight-bold">Style:</span>
            {{productDetail.style}}
          </div>
          <div>
            <span class="mr-1 font-weight-bold">Color:</span>
            {{productDetail.color}}
          </div>
          <div>
            <span class="mr-1 font-weight-bold">Width:</span>
            {{productDetail.width}}
          </div>
          <div>
            <span class="mr-1 font-weight-bold">Rabbet: </span>
            {{productDetail.rabbet}}
          </div>
          <div>
            <span class="mr-1 font-weight-bold">Height: </span>
            {{productDetail.height}}
          </div>
        </div>
      </div>
    </div>
  </div>

